import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Directive, Input, Output, HostListener, LOCALE_ID, Component, ViewEncapsulation, Optional, Self, Inject, ViewChild, HostBinding, NgModule } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import * as i2 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i4 from 'rxjs';
import { Subject } from 'rxjs';
import * as i1 from 'ngx-device-detector';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i3 from '@angular/cdk/a11y';
import * as moment from 'moment';
import moment__default from 'moment';
import * as i6 from '@busacca/ng-pick-datetime';
import { MomentDateTimeAdapter, OwlDateTimeModule, OwlMomentDateTimeModule, DateTimeAdapter, OWL_DATE_TIME_FORMATS } from '@busacca/ng-pick-datetime';
import * as i5 from '@angular/material/core';
import { mixinErrorState } from '@angular/material/core';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

class DatetimeControlService {
    constructor() {
        // noop
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

function dateValidate(format) {
    return (control) => {
        format = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
        // console.log('dateValidate:', control.value, format, moment(control.value, format, true).isValid());
        if (control.value && !moment__default(control.value, format, true).isValid()) {
            return { dateTimeInvalid: true };
        }
        return null;
    };
}

function hourValidator(val, position) {
    // 00-23:xx
    if (position === 0) {
        if (+val > 2) {
            return false;
        }
    }
    if (position === 1) {
        if (+val[position - 1] === 2) {
            if (+val[position] > 3) {
                return false;
            }
        }
    }
    return true;
}

function minuteValidator(val, position) {
    // xx:00-59
    if (position === 0) {
        if (+val > 5) {
            return false;
        }
    }
    return true;
}

function dayValidator(val, position) {
    if (position === 0) {
        if (+val > 3) {
            return false;
        }
    }
    if (position === 1) {
        if (+val[position - 1] === 0) {
            if (+val[position] === 0) {
                return false;
            }
        }
        if (+val[position - 1] === 3) {
            if (+val[position] > 1) {
                return false;
            }
        }
    }
    return true;
}

function monthValidator(val, position) {
    if (position === 0) {
        if (+val > 1) {
            return false;
        }
    }
    if (position === 1) {
        if (+val[position - 1] === 0) {
            if (+val[position] === 0) {
                return false;
            }
        }
        if (+val[position - 1] === 1) {
            if (+val[position] > 2) {
                return false;
            }
        }
    }
    return true;
}

function yearValidator(val, position) {
    if (position === 0) {
        if (+val < 1 || +val > 9) {
            return false;
        }
    }
    if (position === 1) {
        if (+val[position - 1] === 1) {
            if (+val[position] < 8) {
                return false;
            }
        }
    }
    if (position === 2) {
        if (+val[position - 2] === 1 && +val[position - 1] === 8) {
            if (+val[position] < 9) {
                return false;
            }
        }
    }
    if (position === 3) {
        if (+val[position - 3] === 1 &&
            +val[position - 2] === 8 &&
            +val[position - 1] === 9) {
            if (+val[position] < 5) {
                return false;
            }
        }
    }
    return true;
}

var Format;
(function (Format) {
    Format["Day"] = "DD";
    Format["Month"] = "MM";
    Format["Year"] = "YYYY";
    Format["Hour"] = "HH";
    Format["Minute"] = "mm";
})(Format || (Format = {}));
class DatetimeMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.momentFormat = 'DD.MM.YYYY HH:mm'; // MM/dd/YYYY HH:mm A
        this.valid = false;
        this.dateSeparatorsRegex = new RegExp(/([./-])/);
        this.timeSeparator = ':';
        this.dateTimeSeparator = ' ';
        this.placeholder = '';
        this.separator = '.';
        this.isDate = false;
        this.isTime = false;
        this.zeroPrefixedFormat = [
            Format.Day,
            Format.Month,
            Format.Hour,
            Format.Minute,
        ];
        // key definitions
        this.keyArrowLeft = 'ArrowLeft';
        this.keyArrowRight = 'ArrowRight';
        this.keyControl = 'Control';
        // F-keys and crt+ are enabled by default, while blocking pasting
        this.specialKeys = [
            'Backspace',
            'Tab',
            'End',
            'Home',
            this.keyArrowLeft,
            this.keyArrowRight,
            'Del',
            'Delete',
        ];
        this.validatorByIndex = {};
        this.formatLengthByIndex = {};
        this.freshFocus = false;
        this.completed = new EventEmitter();
        this.accepted = new EventEmitter();
        this._separatorPositions = [];
    }
    get input() {
        return this.elementRef.nativeElement;
    }
    get formats() {
        let result = [];
        this.momentFormat.split(this.dateTimeSeparator).forEach((part) => {
            const separatorPosition = part.search(this.dateSeparatorsRegex);
            // console.log('Separator detection:', part, separatorPosition);
            if (separatorPosition !== -1) {
                this.separator = part[separatorPosition];
            }
            result = result.concat(part.split(part.includes(this.timeSeparator)
                ? this.timeSeparator
                : this.separator));
        });
        return result;
    }
    get separatorPositions() {
        return this._separatorPositions;
    }
    getPreviousSeparatorPosition(position) {
        let previousSeparator = this.separatorPositions
            .filter((value) => {
            return value < position;
        })
            .pop();
        if (previousSeparator === undefined) {
            previousSeparator = -1;
        }
        return previousSeparator;
    }
    getNextSeparatorPosition(position) {
        let previousSeparator = this.separatorPositions
            .filter((value) => {
            return value > position;
        })
            .shift();
        if (previousSeparator === undefined) {
            previousSeparator = -1;
        }
        return previousSeparator;
    }
    isSeparatorPosition(position) {
        return this.separatorPositions.includes(position);
    }
    getSeparator(position) {
        return this.momentFormat[position];
    }
    moveOnSeparator(position, step = 1, stayOnSeparator = false) {
        position += step;
        // console.log('moveOnSeparator: Separator position detection -', position);
        if (this.isSeparatorPosition(position)) {
            if (!stayOnSeparator && step > 0) {
                position += step;
            }
            // console.log('moveOnSeparator: Separator position detected, moving', position);
            this.setCaretPosition(position);
            return true;
        }
        return false;
    }
    /**
     * Method tests if special character is allowed
     *
     * @param event
     * @protected
     */
    allowSpecialKey(event) {
        if (event.getModifierState && event.getModifierState(this.keyControl)) {
            return true; // allow ctr + key
        }
        // allow F-keys
        if (event.key.match(/^F[\d]+$/)) {
            return true;
        }
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return true;
        }
        // console.log('Blocked key:', event);
        return false;
    }
    onKeyDown(event) {
        if (this.valid) {
            // console.log(event);
            const current = this.input.value;
            let position = this.input.selectionStart;
            const selectionEnd = this.input.selectionEnd;
            const next = [
                current.slice(0, position),
                event.key === 'Decimal' ? '.' : event.key,
                current.slice(selectionEnd),
            ].join('');
            const selectionLength = selectionEnd - position;
            // allow backspace only from the end or if complete selection
            if (event.code.toLowerCase().includes('backspace') &&
                selectionEnd !== 0) {
                // console.log('No backspace:', position, selectionEnd, this.input.value.length);
                const count = selectionLength === 0 ? 1 : selectionLength;
                for (let i = 0; i < count; i++) {
                    const backPosition = selectionEnd - i - 1;
                    this.replaceValueOnPosition(this.placeholder[backPosition], backPosition);
                    if (count === 1) {
                        position -= 1;
                    }
                }
                this.setCaretPosition(position);
                this.moveOnSeparator(position, -1);
                event.preventDefault();
                return;
            }
            // allow delete only if complete selection
            if (event.code.toLowerCase().includes('del') &&
                position < this.input.value.length) {
                // console.log('No delete:', position, selectionEnd, this.input.value.length);
                const count = selectionLength === 0 ? 1 : selectionLength;
                for (let i = 0; i < count; i++) {
                    this.replaceValueOnPosition(this.placeholder[position], position);
                    position += 1;
                }
                this.setCaretPosition(position);
                this.moveOnSeparator(position - 1);
                event.preventDefault();
                return;
            }
            if (this.isSeparatorPosition(position) &&
                event.key === this.getSeparator(position)) {
                this.replaceValueOnPosition(event.key, position);
                event.preventDefault();
                return; // allow separator
            }
            // allow special keys
            if (this.allowSpecialKey(event)) {
                if (event.key === this.keyArrowLeft) {
                    this.moveOnSeparator(position - 3, 1, false);
                }
                if (event.key === this.keyArrowRight) {
                    this.moveOnSeparator(position, 1, true);
                }
                return;
            }
            // only digits allowed
            if (next && !String(event.key).match(/^[\d]$/)) {
                event.preventDefault();
                return;
            }
            // console.log('Key down:', current, position, selectionEnd, next);
            if (this.isSeparatorPosition(position)) {
                // console.log('Separator position:', position);
                position = this.replaceValueOnPosition(this.getSeparator(position), position);
            }
            const previousSeparator = this.getPreviousSeparatorPosition(position);
            /*
              console.log('Position:', position);
              console.log('Delta:', position - previousSeparator - 1);
              console.log('Validating string:',
              this.replaceValueOnPositionInput(this.input.value, event.key, position, previousSeparator + 1, false),
              position - previousSeparator - 1, this.input.value);
             */
            const relativePosition = position - previousSeparator - 1;
            const replacementString = this.isValidCharacter(position, relativePosition, this.replaceValueOnPositionInput(this.input.value, event.key, position, previousSeparator + 1, false));
            if (replacementString !== false) {
                position = position - relativePosition;
                this.replaceValueOnPosition(replacementString, position);
                position += replacementString.length - 1;
                this.moveOnSeparator(position);
            }
            event.preventDefault();
            return;
        }
    }
    isValidCharacter(position, relativePosition, validatedSubstring) {
        const validator = this.validatorByIndex[position];
        if (validator === undefined) {
            return false;
        }
        // console.log('Validated substring:', validatedSubstring, relativePosition, validator.format);
        let substringValid = validator.validate(validatedSubstring, relativePosition);
        // try to prefix '0' character only for specific validators
        if (!substringValid &&
            relativePosition === 0 &&
            this.zeroPrefixedFormat.includes(validator.format)) {
            validatedSubstring = '0' + validatedSubstring[0];
            // console.log('new substring:', validatedSubstring);
            substringValid = validator.validate(validatedSubstring, 1);
        }
        if (!substringValid) {
            return false;
        }
        return validatedSubstring;
    }
    onMouseMove(e) {
        e.preventDefault();
    }
    onInput() {
        this.input.dispatchEvent(new Event('change'));
        this.accepted.emit(this.input.value);
        if (this.input.value.length === this.momentFormat.length &&
            !this.input.value.includes(this.placeholder)) {
            this.completed.emit(this.input.value);
        }
    }
    onFocus() {
        this.freshFocus = true; // needs to be handled by onclick, the first click identification
        // console.log('onFocus:', event);
        if (this.input.value.length === 0) {
            this.replaceValueOnPosition(this.placeholder, 0);
            this.selectBlock(0);
        }
    }
    onBlur() {
        if (this.input.value === this.placeholder) {
            this.updateValue(''); // reset value to empty string, if placeholder is intact
        }
    }
    onPaste(e) {
        // console.log('Paste disabled');
        e.preventDefault();
    }
    selectBlock(position) {
        if (position === this.input.value.length && this.freshFocus) {
            position = 0; // select first block on focus, if position at the end
        }
        if (this.isSeparatorPosition(position)) {
            position--;
        }
        const previousSeparator = this.getPreviousSeparatorPosition(position);
        const nextSeparator = this.getNextSeparatorPosition(position); // find next separator
        // console.log('Position:', position, previousSeparator, nextSeparator, this.freshFocus);
        this.input.setSelectionRange(previousSeparator + 1, nextSeparator === -1 ? this.input.value.length : nextSeparator);
        this.freshFocus = false; // already handled
    }
    onClick() {
        // console.log('click:', event, this.input.selectionStart, this.input.selectionEnd);
        if (this.input.selectionStart === this.input.selectionEnd) {
            this.selectBlock(this.input.selectionStart);
        }
    }
    /**
     * Move cursor to defined position
     *
     * @param caretPos number
     * @protected
     */
    setCaretPosition(caretPos) {
        const el = this.input;
        // console.log('Setting cursor position:', caretPos);
        // el.value = el.value;
        // ^ this is used to not only get "focus", but
        // to make sure we don't have it everything -selected-
        // (it causes an issue in chrome, and having it doesn't hurt any other browser)
        if (el !== null) {
            // (el.selectionStart === 0 added for Firefox bug)
            if (el.selectionStart || el.selectionStart === 0) {
                el.focus();
                el.setSelectionRange(caretPos, caretPos);
                return true;
            }
            else {
                // fail city, fortunately this never happens (as far as I've tested) :)
                el.focus();
                return false;
            }
        }
    }
    /**
     * Inserts replacement string on given position, while overwriting symbols
     *
     * @param val string Original string value, which will be affected by the replacement.
     * @param replace string String to be used as a replacement
     * @param pos number Start position for the replacement
     * @param start number Start position to get rid of prefix within the original value
     * @param keepSuffix bool Whether to keep the rest of the original string after the replacement
     * @protected
     */
    replaceValueOnPositionInput(val, replace, pos, start = 0, keepSuffix = true) {
        return (val.slice(start, pos) +
            replace +
            (keepSuffix ? val.slice(pos + replace.length) : ''));
    }
    replaceValueOnPosition(val, pos) {
        // console.log('Replacing value:', pos, val);
        const newPos = pos + val.length;
        // this.input.value = this.input.value.slice(0, pos) + val + this.input.value.slice(newPos);
        this.updateValue(this.replaceValueOnPositionInput(this.input.value, val, pos));
        // set cursor position position
        this.setCaretPosition(newPos);
        return newPos;
    }
    /**
     * Method replaces value of the input item with given string completely and dispatches input event
     * @param val
     * @protected
     */
    updateValue(val) {
        this.input.value = val;
        // propagate change of input
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    ngOnInit() {
        this.formats.forEach((f) => {
            // eslint-disable-next-line @typescript-eslint/ban-types
            let validator;
            switch (f) {
                case Format.Day:
                    validator = dayValidator;
                    this.isDate = true;
                    this.placeholder += '__';
                    break;
                case Format.Month:
                    validator = monthValidator;
                    this.isDate = true;
                    this.placeholder += '__';
                    break;
                case Format.Year:
                    validator = yearValidator;
                    this.isDate = true;
                    this.placeholder += '____';
                    break;
                case Format.Hour:
                    validator = hourValidator;
                    this.isTime = true;
                    this.placeholder += '--';
                    break;
                case Format.Minute:
                    validator = minuteValidator;
                    this.isTime = true;
                    this.placeholder += '--';
                    break;
                default:
                    console.error('Unknown format:', f);
            }
            const position = this.momentFormat.indexOf(f);
            const separatorPosition = position + f.length;
            if (separatorPosition < this.momentFormat.length) {
                this._separatorPositions.push(separatorPosition);
                this.placeholder += this.getSeparator(separatorPosition);
            }
            for (let index = position; index < position + f.length; index++) {
                this.validatorByIndex[index] = { validate: validator, format: f };
                this.formatLengthByIndex[index] = f.length;
            }
        });
        this.valid = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeMaskDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: DatetimeMaskDirective, selector: "[inputDateTime]", inputs: { momentFormat: ["inputDateTime", "momentFormat"] }, outputs: { completed: "completed", accepted: "accepted" }, host: { listeners: { "keydown": "onKeyDown($event)", "mousemove": "onMouseMove($event)", "input": "onInput($event)", "focus": "onFocus($event)", "blur": "onBlur($event)", "paste": "onPaste($event)", "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[inputDateTime]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { momentFormat: [{
                type: Input,
                args: ['inputDateTime']
            }], completed: [{
                type: Output
            }], accepted: [{
                type: Output
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onMouseMove: [{
                type: HostListener,
                args: ['mousemove', ['$event']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], onFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

var DatetimeControlPickerType;
(function (DatetimeControlPickerType) {
    DatetimeControlPickerType["both"] = "both";
    DatetimeControlPickerType["calendar"] = "calendar";
    DatetimeControlPickerType["timer"] = "timer";
})(DatetimeControlPickerType || (DatetimeControlPickerType = {}));
// to use Angular/material/core/error-state.ts - mixinErrorState
class DatetimeControlBase {
    constructor(_parentFormGroup, _parentForm, _defaultErrorStateMatcher, ngControl, stateChanges) {
        this._parentFormGroup = _parentFormGroup;
        this._parentForm = _parentForm;
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this.ngControl = ngControl;
        this.stateChanges = stateChanges;
    }
}
const _DatetimeControlMixinBase = mixinErrorState(DatetimeControlBase);
class DatetimeControlComponent extends _DatetimeControlMixinBase {
    static { this.nextId = 0; }
    constructor(deviceService, ngControl, fm, elRef, appLocale, _parentFormGroup, _parentForm, stateChanges, _defaultErrorStateMatcher) {
        super(_parentFormGroup, _parentForm, _defaultErrorStateMatcher, ngControl, stateChanges);
        this.deviceService = deviceService;
        this.ngControl = ngControl;
        this.fm = fm;
        this.elRef = elRef;
        this.appLocale = appLocale;
        this._parentFormGroup = _parentFormGroup;
        this._parentForm = _parentForm;
        this.stateChanges = stateChanges;
        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
        this._placeholder = '';
        this._required = false;
        this._disabled = false;
        this.id = `datetime-input-${DatetimeControlComponent.nextId++}`;
        this._dateValue = null; // zde si držím vnitřní hodnotu
        this.pickerType = DatetimeControlPickerType.both;
        this.forceMobile = coerceBooleanProperty(false);
        this.min = null;
        this.max = null;
        // focused
        this.focused = false;
        this.controlType = 'datetime-input';
        // Disabled directive
        this.disabled = false;
        this.onInitCalled = false; // flag to check if onInit was called
        this.disableState = false; // store setDisabledState input value so it can be validated after initialization
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.propagateChange = (_) => { };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onTouched = () => { };
        // If stateChanges is null I have to assign it new Subject, otherwise it throws error
        if (!this.stateChanges) {
            this.stateChanges = new Subject();
        }
        // Replace the provider from above with this
        if (this.ngControl != null) {
            // Setting the value accessor directly (instead of using
            // the providers) to avoid running into a circular import
            this.ngControl.valueAccessor = this;
        }
        this.form = new UntypedFormGroup({
            inputDate: new UntypedFormControl(),
        });
        fm.monitor(elRef.nativeElement, true).subscribe((origin) => {
            this.focused = !!origin;
            this.stateChanges?.next();
        });
        this.dateChangeSubscription =
            this.form.controls.inputDate.valueChanges.subscribe((value) => {
                this.applyChange(value);
            });
    }
    // Placeholder implementation
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(plh) {
        this._placeholder = plh;
        this.stateChanges?.next();
    }
    // Required directive
    get required() {
        return this._required;
    }
    set required(req) {
        this._required = coerceBooleanProperty(req);
        this.stateChanges?.next();
    }
    get empty() {
        // console.log('Empty:', this._dateValue);
        return this._dateValue === null || this._dateValue === undefined;
    }
    ngDoCheck() {
        if (this.ngControl) {
            this.updateErrorState(); // error state mixin
        }
    }
    get value() {
        return this._dateValue;
    }
    set value(val) {
        this._dateValue = val;
        // console.log('value has changed:', val);
        this.stateChanges?.next();
        this.propagateChange(this.value);
        this.onTouched();
    }
    applyChange(value) {
        if (typeof value === 'string' || value instanceof moment__default) {
            // console.log('String or Moment value change detected: ', value);
            const momentDate = moment__default(value, this.getFormat(), true);
            value = momentDate.isValid() ? momentDate.toDate() : value;
            if (!momentDate.isValid()) {
                // try ISO format
                const momentDate = moment__default(value, this.getISOFormat(), true);
                value = momentDate.isValid() ? momentDate.toDate() : value;
            }
        }
        // console.log('Value change detected:', value, this.getFormat(), this.getISOFormat());
        if (value instanceof Date) {
            value = value.toISOString();
        }
        this.value = value;
    }
    setDisabledState(isDisabled) {
        this.disableState = isDisabled;
        const ctrl = this.ngControl.control;
        if (isDisabled) {
            this.form.get('inputDate').disable();
            if (ctrl && !ctrl.disabled) {
                ctrl.disable();
            }
        }
        else {
            this.form.get('inputDate').enable();
            if (ctrl && !ctrl.enabled) {
                ctrl.enable();
            }
        }
        // wait until onInit is called, so I don't overwrite "disabled" initial input value
        if (this.onInitCalled) {
            this.disabled = isDisabled;
        }
        this.stateChanges?.next();
    }
    setDescribedByIds(ids) {
        this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
        const sourceElement = event.target.tagName.toLowerCase();
        if (sourceElement !== 'input' && sourceElement !== 'mat-icon') {
            this.elRef.nativeElement.querySelector('input').focus();
        }
    }
    ngOnInit() {
        // console.log('locale 2:', this.appLocale);
        // moment.locale(this.appLocale.slice(0,2));
        this.addValidator(dateValidate(this.getFormat()));
        this.onInitCalled = true;
        if (this.disableState !== this.disabled) {
            this.setDisabledState(true); // set initial disabled state
        }
    }
    ngOnChanges(changes) {
        if (changes['disabled']) {
            this.setDisabledState(this.disabled); // update disabled state
        }
    }
    sr() {
        this.form.controls['duration'].disable();
    }
    addValidator(validator) {
        if (!this.ngControl) {
            console.error('Form control is not available');
        }
        // console.log('Updating validator:', this.ngControl);
        if (this.ngControl['_rawValidators']) {
            this.ngControl.control.setValidators(this.ngControl['_rawValidators'].concat(validator));
            this.ngControl.control.updateValueAndValidity();
        }
    }
    ngOnDestroy() {
        if (this.dateChangeSubscription) {
            this.dateChangeSubscription.unsubscribe();
        }
        this.stateChanges?.complete();
        this.fm.stopMonitoring(this.elRef.nativeElement);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        if (value) {
            this.applyChange(value);
        }
        else {
            this.value = null;
        }
        this.form.controls.inputDate.setValue(this.value, { emitEvent: false });
    }
    getMobileType() {
        switch (this.pickerType) {
            case DatetimeControlPickerType.both:
                return 'datetime-local';
            case DatetimeControlPickerType.calendar:
                return 'date';
            case DatetimeControlPickerType.timer:
                return 'time';
            default:
                return 'date';
        }
    }
    get shouldLabelFloat() {
        return this.focused || !this.empty;
    }
    getFormat() {
        const localeData = moment__default.localeData(moment__default.locale());
        switch (this.pickerType) {
            case DatetimeControlPickerType.both:
                return localeData.longDateFormat('L') + ' HH:mm';
            case DatetimeControlPickerType.calendar:
                return localeData.longDateFormat('L');
            case DatetimeControlPickerType.timer:
                return 'HH:mm';
            default:
                return localeData.longDateFormat('L');
        }
    }
    getISOFormat() {
        switch (this.pickerType) {
            case DatetimeControlPickerType.both:
                return 'YYYY-MM-DD[T]HH:mm';
            case DatetimeControlPickerType.calendar:
                return 'YYYY-MM-DD';
            case DatetimeControlPickerType.timer:
                return 'HH:mm';
            default:
                return 'YYYY-MM-DD';
        }
    }
    onComplete(value) {
        // console.log('Completed:', value);
        this.applyChange(value);
    }
    onAccept(value) {
        this.owlDateTime.close();
    }
    calendarChange() {
        if (this.pickerType === DatetimeControlPickerType.both ||
            this.pickerType === DatetimeControlPickerType.timer) {
            const timeElements = document.querySelectorAll('.owl-dt-timer-input');
            const hourElement = timeElements[0];
            const minuteElement = timeElements[1];
            // set validators
            this.setValidator(hourElement, hourValidator, minuteElement);
            this.setValidator(minuteElement, minuteValidator);
            if (this.pickerType === DatetimeControlPickerType.both) {
                const el = document.getElementsByClassName('owl-dt-calendar-main');
                el[0].addEventListener('click', () => {
                    // console.log('Clicked');
                    this.daySelected();
                    hourElement.focus();
                });
            }
            if (this.pickerType === DatetimeControlPickerType.timer) {
                hourElement.focus();
            }
        }
    }
    setValidator(el, validator, nextElement = null) {
        el.addEventListener('focus', () => {
            el.setSelectionRange(0, el.value.length);
        });
        el.addEventListener('keydown', (event) => {
            // console.log('Event', el.selectionStart, el.selectionEnd, event.key);
            if (event.key.match(/^[a-zA-Z]$/)) {
                event.preventDefault();
                return false;
            }
            if (event.key === 'Enter') {
                // akceptovat vybrané hodnoty
                this.owlDateTime.confirmSelect();
            }
            // validate and overwrite only numeric
            if (event.key.match(/[0-9]/)) {
                // console.log('Val:', el.value, 'Position:');
                const newString = el.value.slice(0, el.selectionStart) + event.key;
                // console.log('New:', newString, 'Position:', el.selectionStart, validator(newString, el.selectionStart));
                if (newString.length > 2 || !validator(newString, el.selectionStart)) {
                    event.preventDefault();
                    return false;
                }
                // overwrite
                el.value = el.value.slice(0, el.selectionStart) + event.key;
                el.dispatchEvent(new Event('input'));
                // skip to next element
                if (nextElement !== null && el.selectionStart === 2) {
                    nextElement.focus(); // skip to next element
                    nextElement.setSelectionRange(0, nextElement.value.length);
                }
                event.preventDefault();
                return false;
            }
        });
    }
    isTimeOnly() {
        return this.pickerType === DatetimeControlPickerType.timer;
    }
    daySelected() {
        // emit?
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlComponent, deps: [{ token: i1.DeviceDetectorService }, { token: i2.NgControl, optional: true, self: true }, { token: i3.FocusMonitor }, { token: i0.ElementRef }, { token: LOCALE_ID }, { token: i2.FormGroupDirective, optional: true }, { token: i2.NgForm, optional: true }, { token: i4.Subject, optional: true }, { token: i5.ErrorStateMatcher }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.0.7", type: DatetimeControlComponent, selector: "datetime-control", inputs: { errorStateMatcher: "errorStateMatcher", placeholder: "placeholder", required: "required", pickerType: "pickerType", userAriaDescribedBy: ["aria-describedby", "userAriaDescribedBy"], forceMobile: "forceMobile", min: "min", max: "max", value: "value", disabled: "disabled" }, host: { properties: { "id": "this.id", "class.floating": "this.shouldLabelFloat" } }, providers: [
            { provide: MatFormFieldControl, useExisting: DatetimeControlComponent },
        ], viewQueries: [{ propertyName: "owlDateTime", first: true, predicate: ["dt"], descendants: true }, { propertyName: "_elementRef", first: true, predicate: ["inpElement"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [formGroup]=\"form\">\n  <div #inpElement *ngIf=\"!deviceService.isMobile() && !forceMobile\">\n    <input\n      [owlDateTime]=\"dt\"\n      [placeholder]=\"placeholder\"\n      formControlName=\"inputDate\"\n      matInput\n      [inputDateTime]=\"getFormat()\"\n      (completed)=\"onComplete($event)\"\n      (accepted)=\"onAccept($event)\"\n      [min]=\"min\"\n      [max]=\"max\"\n      autocomplete=\"disabled\"\n    />\n    <owl-date-time\n      #dt\n      [pickerType]=\"pickerType\"\n      [panelClass]=\"id\"\n      (afterPickerOpen)=\"calendarChange()\"\n    ></owl-date-time>\n  </div>\n  <div *ngIf=\"deviceService.isMobile() || forceMobile\">\n    <input\n      [type]=\"getMobileType()\"\n      [id]=\"id\"\n      matInput\n      formControlName=\"inputDate\"\n      [min]=\"min\"\n      [max]=\"max\"\n    />\n  </div>\n</div>\n", styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}@media screen and (-ms-high-contrast: active){.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}}.cdk-overlay-dark-backdrop{background:#00000049}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.owl-dialog-container{position:relative;pointer-events:auto;box-sizing:border-box;display:block;padding:1.5em;box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;border-radius:2px;overflow:auto;background:#fff;color:#000000de;width:100%;height:100%;outline:none}.owl-dt-container,.owl-dt-container *{box-sizing:border-box}.owl-dt-container{display:block;font-size:1rem;background:#fff;pointer-events:auto;z-index:1000}.owl-dt-container-row{border-bottom:1px solid rgba(0,0,0,.12)}.owl-dt-container-row:last-child{border-bottom:none}.owl-dt-calendar{display:flex;flex-direction:column;width:100%}.owl-dt-calendar-control{display:flex;align-items:center;font-size:1em;width:100%;padding:.5em;color:#000}.owl-dt-calendar-control .owl-dt-calendar-control-content{flex:1 1 auto;display:flex;justify-content:center;align-items:center}.owl-dt-calendar-control .owl-dt-calendar-control-content .owl-dt-calendar-control-button{padding:0 .8em}.owl-dt-calendar-control .owl-dt-calendar-control-content .owl-dt-calendar-control-button:hover{background-color:#0000001f}.owl-dt-calendar-main{display:flex;flex-direction:column;flex:1 1 auto;padding:0 .5em .5em;outline:0}.owl-dt-calendar-view{display:block;flex:1 1 auto}.owl-dt-calendar-multi-year-view{display:flex;align-items:center}.owl-dt-calendar-multi-year-view .owl-dt-calendar-table{width:calc(100% - 3em)}.owl-dt-calendar-multi-year-view .owl-dt-calendar-table .owl-dt-calendar-header th{padding-bottom:.25em}.owl-dt-calendar-table{width:100%;border-collapse:collapse;border-spacing:0}.owl-dt-calendar-table .owl-dt-calendar-header{color:#0006}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-weekdays th{font-size:.7em;font-weight:400;text-align:center;padding-bottom:1em}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-calendar-table-divider{position:relative;height:1px;padding-bottom:.5em}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-calendar-table-divider:after{content:\"\";position:absolute;top:0;left:-.5em;right:-.5em;height:1px;background:#0000001f}.owl-dt-calendar-table .owl-dt-calendar-cell{position:relative;height:0;line-height:0;text-align:center;outline:0;color:#000000d9;-webkit-appearance:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent}.owl-dt-calendar-table .owl-dt-calendar-cell-content{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;font-size:.8em;line-height:1;border:1px solid transparent;border-radius:999px;color:inherit;cursor:pointer}.owl-dt-calendar-table .owl-dt-calendar-cell-out{opacity:.2}.owl-dt-calendar-table .owl-dt-calendar-cell-today:not(.owl-dt-calendar-cell-selected){border-color:#0006}.owl-dt-calendar-table .owl-dt-calendar-cell-selected{color:#ffffffd9;background-color:#3f51b5}.owl-dt-calendar-table .owl-dt-calendar-cell-selected.owl-dt-calendar-cell-today{box-shadow:inset 0 0 0 1px #ffffffd9}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled{cursor:default}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected){color:#0006}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-content.owl-dt-calendar-cell-selected{opacity:.4}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-today:not(.owl-dt-calendar-cell-selected){border-color:#0003}.owl-dt-calendar-table .owl-dt-calendar-cell-active:focus>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected),.owl-dt-calendar-table :not(.owl-dt-calendar-cell-disabled):hover>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected){background-color:#0000000a}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range{background:#3f51b533}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range.owl-dt-calendar-cell-range-from{border-top-left-radius:999px;border-bottom-left-radius:999px}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range.owl-dt-calendar-cell-range-to{border-top-right-radius:999px;border-bottom-right-radius:999px}.owl-dt-timer{display:flex;justify-content:center;width:100%;height:7em;padding:.5em;outline:none}.owl-dt-timer-box{position:relative;display:inline-flex;flex-direction:column;align-items:center;width:25%;height:100%}.owl-dt-timer-content{flex:1 1 auto;display:flex;justify-content:center;align-items:center;width:100%;margin:.2em 0}.owl-dt-timer-content .owl-dt-timer-input{display:block;width:2em;text-align:center;border:1px solid rgba(0,0,0,.5);border-radius:3px;outline:medium none;font-size:1.2em;padding:.2em}.owl-dt-timer-divider{display:inline-block;align-self:flex-end;position:absolute;width:.6em;height:100%;left:-.3em}.owl-dt-timer-divider:before,.owl-dt-timer-divider:after{content:\"\";display:inline-block;width:.35em;height:.35em;position:absolute;left:50%;border-radius:50%;transform:translate(-50%);background-color:currentColor}.owl-dt-timer-divider:before{top:35%}.owl-dt-timer-divider:after{bottom:35%}.owl-dt-control-button{-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;margin:0;padding:0;background-color:transparent;font-size:1em;color:inherit}.owl-dt-control-button .owl-dt-control-button-content{position:relative;display:inline-flex;justify-content:center;align-items:center;outline:none}.owl-dt-control-period-button .owl-dt-control-button-content{height:1.5em;padding:0 .5em;border-radius:3px;transition:background-color .1s linear}.owl-dt-control-period-button:hover>.owl-dt-control-button-content{background-color:#0000001f}.owl-dt-control-period-button .owl-dt-control-button-arrow{display:flex;justify-content:center;align-items:center;width:1em;height:1em;margin:.1em;transition:transform .2s ease}.owl-dt-control-arrow-button .owl-dt-control-button-content{padding:0;border-radius:50%;width:1.5em;height:1.5em}.owl-dt-control-arrow-button[disabled]{color:#0006;cursor:default}.owl-dt-control-arrow-button svg{width:50%;height:50%;fill:currentColor}.owl-dt-inline-container,.owl-dt-popup-container{position:relative;width:18.5em;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.owl-dt-inline-container .owl-dt-calendar,.owl-dt-inline-container .owl-dt-timer,.owl-dt-popup-container .owl-dt-calendar,.owl-dt-popup-container .owl-dt-timer{width:100%}.owl-dt-inline-container .owl-dt-calendar,.owl-dt-popup-container .owl-dt-calendar{height:20.25em}.owl-dt-dialog-container{max-height:95vh;margin:-1.5em}.owl-dt-dialog-container .owl-dt-calendar{min-width:250px;min-height:330px;max-width:750px;max-height:750px}.owl-dt-dialog-container .owl-dt-timer{min-width:250px;max-width:750px}@media all and (orientation: landscape){.owl-dt-dialog-container .owl-dt-calendar{width:58vh;height:62vh}.owl-dt-dialog-container .owl-dt-timer{width:58vh}}@media all and (orientation: portrait){.owl-dt-dialog-container .owl-dt-calendar{width:80vw;height:80vw}.owl-dt-dialog-container .owl-dt-timer{width:80vw}}.owl-dt-container-buttons{display:flex;width:100%;height:2em;color:#3f51b5}.owl-dt-container-control-button{font-size:1em;width:50%;height:100%;border-radius:0}.owl-dt-container-control-button .owl-dt-control-button-content{height:100%;width:100%;transition:background-color .1s linear}.owl-dt-container-control-button:hover .owl-dt-control-button-content{background-color:#0000001a}.owl-dt-container-info{padding:0 .5em;cursor:pointer;-webkit-tap-highlight-color:transparent}.owl-dt-container-info .owl-dt-container-range{outline:none}.owl-dt-container-info .owl-dt-container-range .owl-dt-container-range-content{display:flex;justify-content:space-between;padding:.5em 0;font-size:.8em}.owl-dt-container-info .owl-dt-container-range:last-child{border-top:1px solid rgba(0,0,0,.12)}.owl-dt-container-info .owl-dt-container-info-active{color:#3f51b5}.owl-dt-container-disabled,.owl-dt-trigger-disabled{opacity:.35;filter:Alpha(Opacity=35);background-image:none;cursor:default!important}.owl-dt-timer-hour12{display:flex;justify-content:center;align-items:center;color:#3f51b5}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box{border:1px solid currentColor;border-radius:2px;transition:background .2s ease}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box .owl-dt-control-button-content{width:100%;height:100%;padding:.5em}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box:focus .owl-dt-control-button-content,.owl-dt-timer-hour12 .owl-dt-timer-hour12-box:hover .owl-dt-control-button-content{background:#3f51b5;color:#fff}.owl-dt-calendar-only-current-month .owl-dt-calendar-cell-out{visibility:hidden;cursor:default}.owl-dt-inline{display:inline-block}.owl-dt-control{outline:none;cursor:pointer}.owl-dt-control .owl-dt-control-content{outline:none}.owl-dt-control:focus>.owl-dt-control-content{background-color:#0000001f}.owl-dt-control:not(:-moz-focusring):focus>.owl-dt-control-content{box-shadow:none}.owl-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}datetime-control input.mat-mdc-input-element{font-family:Liberation Mono,Monofur,Lucida Console,Consolas,monospace}\n"], dependencies: [{ kind: "directive", type: i6.OwlDateTimeInputDirective, selector: "input[owlDateTime]", inputs: ["owlDateTime", "owlDateTimeFilter", "_disabled", "min", "max", "selectMode", "rangeSeparator", "value", "values"], outputs: ["dateTimeChange", "dateTimeInput"], exportAs: ["owlDateTimeInput"] }, { kind: "component", type: i6.OwlDateTimeComponent, selector: "owl-date-time", inputs: ["backdropClass", "panelClass", "startAt", "pickerType", "pickerMode", "disabled", "opened", "scrollStrategy"], outputs: ["afterPickerClosed", "afterPickerOpen", "yearSelected", "monthSelected"], exportAs: ["owlDateTime"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i8.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: DatetimeMaskDirective, selector: "[inputDateTime]", inputs: ["inputDateTime"], outputs: ["completed", "accepted"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'datetime-control', providers: [
                        { provide: MatFormFieldControl, useExisting: DatetimeControlComponent },
                    ], encapsulation: ViewEncapsulation.None, template: "<div [formGroup]=\"form\">\n  <div #inpElement *ngIf=\"!deviceService.isMobile() && !forceMobile\">\n    <input\n      [owlDateTime]=\"dt\"\n      [placeholder]=\"placeholder\"\n      formControlName=\"inputDate\"\n      matInput\n      [inputDateTime]=\"getFormat()\"\n      (completed)=\"onComplete($event)\"\n      (accepted)=\"onAccept($event)\"\n      [min]=\"min\"\n      [max]=\"max\"\n      autocomplete=\"disabled\"\n    />\n    <owl-date-time\n      #dt\n      [pickerType]=\"pickerType\"\n      [panelClass]=\"id\"\n      (afterPickerOpen)=\"calendarChange()\"\n    ></owl-date-time>\n  </div>\n  <div *ngIf=\"deviceService.isMobile() || forceMobile\">\n    <input\n      [type]=\"getMobileType()\"\n      [id]=\"id\"\n      matInput\n      formControlName=\"inputDate\"\n      [min]=\"min\"\n      [max]=\"max\"\n    />\n  </div>\n</div>\n", styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}@media screen and (-ms-high-contrast: active){.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}}.cdk-overlay-dark-backdrop{background:#00000049}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.owl-dialog-container{position:relative;pointer-events:auto;box-sizing:border-box;display:block;padding:1.5em;box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;border-radius:2px;overflow:auto;background:#fff;color:#000000de;width:100%;height:100%;outline:none}.owl-dt-container,.owl-dt-container *{box-sizing:border-box}.owl-dt-container{display:block;font-size:1rem;background:#fff;pointer-events:auto;z-index:1000}.owl-dt-container-row{border-bottom:1px solid rgba(0,0,0,.12)}.owl-dt-container-row:last-child{border-bottom:none}.owl-dt-calendar{display:flex;flex-direction:column;width:100%}.owl-dt-calendar-control{display:flex;align-items:center;font-size:1em;width:100%;padding:.5em;color:#000}.owl-dt-calendar-control .owl-dt-calendar-control-content{flex:1 1 auto;display:flex;justify-content:center;align-items:center}.owl-dt-calendar-control .owl-dt-calendar-control-content .owl-dt-calendar-control-button{padding:0 .8em}.owl-dt-calendar-control .owl-dt-calendar-control-content .owl-dt-calendar-control-button:hover{background-color:#0000001f}.owl-dt-calendar-main{display:flex;flex-direction:column;flex:1 1 auto;padding:0 .5em .5em;outline:0}.owl-dt-calendar-view{display:block;flex:1 1 auto}.owl-dt-calendar-multi-year-view{display:flex;align-items:center}.owl-dt-calendar-multi-year-view .owl-dt-calendar-table{width:calc(100% - 3em)}.owl-dt-calendar-multi-year-view .owl-dt-calendar-table .owl-dt-calendar-header th{padding-bottom:.25em}.owl-dt-calendar-table{width:100%;border-collapse:collapse;border-spacing:0}.owl-dt-calendar-table .owl-dt-calendar-header{color:#0006}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-weekdays th{font-size:.7em;font-weight:400;text-align:center;padding-bottom:1em}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-calendar-table-divider{position:relative;height:1px;padding-bottom:.5em}.owl-dt-calendar-table .owl-dt-calendar-header .owl-dt-calendar-table-divider:after{content:\"\";position:absolute;top:0;left:-.5em;right:-.5em;height:1px;background:#0000001f}.owl-dt-calendar-table .owl-dt-calendar-cell{position:relative;height:0;line-height:0;text-align:center;outline:0;color:#000000d9;-webkit-appearance:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent}.owl-dt-calendar-table .owl-dt-calendar-cell-content{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;font-size:.8em;line-height:1;border:1px solid transparent;border-radius:999px;color:inherit;cursor:pointer}.owl-dt-calendar-table .owl-dt-calendar-cell-out{opacity:.2}.owl-dt-calendar-table .owl-dt-calendar-cell-today:not(.owl-dt-calendar-cell-selected){border-color:#0006}.owl-dt-calendar-table .owl-dt-calendar-cell-selected{color:#ffffffd9;background-color:#3f51b5}.owl-dt-calendar-table .owl-dt-calendar-cell-selected.owl-dt-calendar-cell-today{box-shadow:inset 0 0 0 1px #ffffffd9}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled{cursor:default}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected){color:#0006}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-content.owl-dt-calendar-cell-selected{opacity:.4}.owl-dt-calendar-table .owl-dt-calendar-cell-disabled>.owl-dt-calendar-cell-today:not(.owl-dt-calendar-cell-selected){border-color:#0003}.owl-dt-calendar-table .owl-dt-calendar-cell-active:focus>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected),.owl-dt-calendar-table :not(.owl-dt-calendar-cell-disabled):hover>.owl-dt-calendar-cell-content:not(.owl-dt-calendar-cell-selected){background-color:#0000000a}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range{background:#3f51b533}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range.owl-dt-calendar-cell-range-from{border-top-left-radius:999px;border-bottom-left-radius:999px}.owl-dt-calendar-table .owl-dt-calendar-cell-in-range.owl-dt-calendar-cell-range-to{border-top-right-radius:999px;border-bottom-right-radius:999px}.owl-dt-timer{display:flex;justify-content:center;width:100%;height:7em;padding:.5em;outline:none}.owl-dt-timer-box{position:relative;display:inline-flex;flex-direction:column;align-items:center;width:25%;height:100%}.owl-dt-timer-content{flex:1 1 auto;display:flex;justify-content:center;align-items:center;width:100%;margin:.2em 0}.owl-dt-timer-content .owl-dt-timer-input{display:block;width:2em;text-align:center;border:1px solid rgba(0,0,0,.5);border-radius:3px;outline:medium none;font-size:1.2em;padding:.2em}.owl-dt-timer-divider{display:inline-block;align-self:flex-end;position:absolute;width:.6em;height:100%;left:-.3em}.owl-dt-timer-divider:before,.owl-dt-timer-divider:after{content:\"\";display:inline-block;width:.35em;height:.35em;position:absolute;left:50%;border-radius:50%;transform:translate(-50%);background-color:currentColor}.owl-dt-timer-divider:before{top:35%}.owl-dt-timer-divider:after{bottom:35%}.owl-dt-control-button{-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;margin:0;padding:0;background-color:transparent;font-size:1em;color:inherit}.owl-dt-control-button .owl-dt-control-button-content{position:relative;display:inline-flex;justify-content:center;align-items:center;outline:none}.owl-dt-control-period-button .owl-dt-control-button-content{height:1.5em;padding:0 .5em;border-radius:3px;transition:background-color .1s linear}.owl-dt-control-period-button:hover>.owl-dt-control-button-content{background-color:#0000001f}.owl-dt-control-period-button .owl-dt-control-button-arrow{display:flex;justify-content:center;align-items:center;width:1em;height:1em;margin:.1em;transition:transform .2s ease}.owl-dt-control-arrow-button .owl-dt-control-button-content{padding:0;border-radius:50%;width:1.5em;height:1.5em}.owl-dt-control-arrow-button[disabled]{color:#0006;cursor:default}.owl-dt-control-arrow-button svg{width:50%;height:50%;fill:currentColor}.owl-dt-inline-container,.owl-dt-popup-container{position:relative;width:18.5em;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.owl-dt-inline-container .owl-dt-calendar,.owl-dt-inline-container .owl-dt-timer,.owl-dt-popup-container .owl-dt-calendar,.owl-dt-popup-container .owl-dt-timer{width:100%}.owl-dt-inline-container .owl-dt-calendar,.owl-dt-popup-container .owl-dt-calendar{height:20.25em}.owl-dt-dialog-container{max-height:95vh;margin:-1.5em}.owl-dt-dialog-container .owl-dt-calendar{min-width:250px;min-height:330px;max-width:750px;max-height:750px}.owl-dt-dialog-container .owl-dt-timer{min-width:250px;max-width:750px}@media all and (orientation: landscape){.owl-dt-dialog-container .owl-dt-calendar{width:58vh;height:62vh}.owl-dt-dialog-container .owl-dt-timer{width:58vh}}@media all and (orientation: portrait){.owl-dt-dialog-container .owl-dt-calendar{width:80vw;height:80vw}.owl-dt-dialog-container .owl-dt-timer{width:80vw}}.owl-dt-container-buttons{display:flex;width:100%;height:2em;color:#3f51b5}.owl-dt-container-control-button{font-size:1em;width:50%;height:100%;border-radius:0}.owl-dt-container-control-button .owl-dt-control-button-content{height:100%;width:100%;transition:background-color .1s linear}.owl-dt-container-control-button:hover .owl-dt-control-button-content{background-color:#0000001a}.owl-dt-container-info{padding:0 .5em;cursor:pointer;-webkit-tap-highlight-color:transparent}.owl-dt-container-info .owl-dt-container-range{outline:none}.owl-dt-container-info .owl-dt-container-range .owl-dt-container-range-content{display:flex;justify-content:space-between;padding:.5em 0;font-size:.8em}.owl-dt-container-info .owl-dt-container-range:last-child{border-top:1px solid rgba(0,0,0,.12)}.owl-dt-container-info .owl-dt-container-info-active{color:#3f51b5}.owl-dt-container-disabled,.owl-dt-trigger-disabled{opacity:.35;filter:Alpha(Opacity=35);background-image:none;cursor:default!important}.owl-dt-timer-hour12{display:flex;justify-content:center;align-items:center;color:#3f51b5}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box{border:1px solid currentColor;border-radius:2px;transition:background .2s ease}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box .owl-dt-control-button-content{width:100%;height:100%;padding:.5em}.owl-dt-timer-hour12 .owl-dt-timer-hour12-box:focus .owl-dt-control-button-content,.owl-dt-timer-hour12 .owl-dt-timer-hour12-box:hover .owl-dt-control-button-content{background:#3f51b5;color:#fff}.owl-dt-calendar-only-current-month .owl-dt-calendar-cell-out{visibility:hidden;cursor:default}.owl-dt-inline{display:inline-block}.owl-dt-control{outline:none;cursor:pointer}.owl-dt-control .owl-dt-control-content{outline:none}.owl-dt-control:focus>.owl-dt-control-content{background-color:#0000001f}.owl-dt-control:not(:-moz-focusring):focus>.owl-dt-control-content{box-shadow:none}.owl-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}datetime-control input.mat-mdc-input-element{font-family:Liberation Mono,Monofur,Lucida Console,Consolas,monospace}\n"] }]
        }], ctorParameters: () => [{ type: i1.DeviceDetectorService }, { type: i2.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i3.FocusMonitor }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i2.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: i2.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i4.Subject, decorators: [{
                    type: Optional
                }] }, { type: i5.ErrorStateMatcher }], propDecorators: { owlDateTime: [{
                type: ViewChild,
                args: ['dt', { static: false }]
            }], errorStateMatcher: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], required: [{
                type: Input
            }], _elementRef: [{
                type: ViewChild,
                args: ['inpElement', { static: false }]
            }], id: [{
                type: HostBinding
            }], pickerType: [{
                type: Input
            }], userAriaDescribedBy: [{
                type: Input,
                args: ['aria-describedby']
            }], forceMobile: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], shouldLabelFloat: [{
                type: HostBinding,
                args: ['class.floating']
            }] } });

class CustomDateTimeAdapter extends MomentDateTimeAdapter {
    setLocale(locale) {
        moment.locale(locale);
        super.setLocale(locale);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: CustomDateTimeAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: CustomDateTimeAdapter }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: CustomDateTimeAdapter, decorators: [{
            type: Injectable
        }] });

class DatetimeControlTriggerComponent {
    constructor(deviceDetector, elRef) {
        this.deviceDetector = deviceDetector;
        this.elRef = elRef;
        this.displayed = true;
        this.empty = false;
        this.styleElement = null;
    }
    ngOnInit() {
        this.displayed = !this.deviceDetector.isMobile(); // do not display on mobile
    }
    onMouseClick() {
        if (this.for) {
            this.createClassElement();
            this.for.owlDateTime.open();
        }
    }
    /**
     * Metoda vytváří css třídu, která zajistí zarovnání dialogu podle ikony triggeru zprava.
     * Nelze měnit přímo css vlastnosti dialogu CDK overlay elementu, protože si je neustále aktualizuje.
     * Zároveň se odsazení zprava počítá podle aktuální pozice elementu, tudíž není možné definovat styl staticky.
     * @protected
     */
    createClassElement() {
        if (this.styleElement === null) {
            this.styleElement = document.createElement('style');
            document.getElementsByTagName('head')[0].append(this.styleElement);
        }
        const vw = document.documentElement.clientWidth > 0
            ? document.documentElement.clientWidth
            : window.innerWidth;
        const coords = this.elRef.nativeElement.getBoundingClientRect();
        const offset = vw - coords.x - coords.width;
        this.styleElement.innerHTML =
            '.owl-dt-popup.' +
                this.for.id +
                ' { left: auto!important; right: ' +
                offset +
                'px!important; }';
    }
    getDefaultIcon() {
        return this.for.isTimeOnly() ? 'access_time' : 'today';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlTriggerComponent, deps: [{ token: i1.DeviceDetectorService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.0.7", type: DatetimeControlTriggerComponent, selector: "datetime-control-trigger", inputs: { for: "for" }, host: { listeners: { "click": "onMouseClick($event)" } }, ngImport: i0, template: `
    <div
      *ngIf="displayed"
      [ngClass]="{ trigger: true, disabled: for.disabled }"
    >
      <span #ref><ng-content></ng-content></span>
      <mat-icon *ngIf="!ref.hasChildNodes()">{{ getDefaultIcon() }}</mat-icon>
    </div>
  `, isInline: true, styles: [".trigger{color:#0000008a;cursor:pointer}.trigger.disabled{color:#0000001a;cursor:unset}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlTriggerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'datetime-control-trigger', template: `
    <div
      *ngIf="displayed"
      [ngClass]="{ trigger: true, disabled: for.disabled }"
    >
      <span #ref><ng-content></ng-content></span>
      <mat-icon *ngIf="!ref.hasChildNodes()">{{ getDefaultIcon() }}</mat-icon>
    </div>
  `, styles: [".trigger{color:#0000008a;cursor:pointer}.trigger.disabled{color:#0000001a;cursor:unset}\n"] }]
        }], ctorParameters: () => [{ type: i1.DeviceDetectorService }, { type: i0.ElementRef }], propDecorators: { for: [{
                type: Input
            }], onMouseClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
const MY_MOMENT_FORMATS = {
    parseInput: 'L HH:mm',
    fullPickerInput: 'L HH:mm',
    datePickerInput: 'L',
    timePickerInput: 'HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
};
class DatetimeControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlModule, declarations: [DatetimeControlComponent,
            DatetimeMaskDirective,
            DatetimeControlTriggerComponent], imports: [OwlDateTimeModule,
            OwlMomentDateTimeModule,
            FormsModule,
            CommonModule,
            MatInputModule,
            ReactiveFormsModule,
            MatIconModule], exports: [DatetimeControlComponent, DatetimeControlTriggerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlModule, providers: [
            { provide: DateTimeAdapter, useClass: CustomDateTimeAdapter },
            { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
        ], imports: [OwlDateTimeModule,
            OwlMomentDateTimeModule,
            FormsModule,
            CommonModule,
            MatInputModule,
            ReactiveFormsModule,
            MatIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DatetimeControlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DatetimeControlComponent,
                        DatetimeMaskDirective,
                        DatetimeControlTriggerComponent,
                    ],
                    imports: [
                        OwlDateTimeModule,
                        OwlMomentDateTimeModule,
                        FormsModule,
                        CommonModule,
                        MatInputModule,
                        ReactiveFormsModule,
                        MatIconModule,
                    ],
                    exports: [DatetimeControlComponent, DatetimeControlTriggerComponent],
                    providers: [
                        { provide: DateTimeAdapter, useClass: CustomDateTimeAdapter },
                        { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
                    ],
                }]
        }] });

/**
 * ValidatorFn generator for comparing date range inputs to ensure the range is correct (from is smaller than to).
 * @param dateFromFieldName The name of the control representing from value within the FromGroup to check.
 * @param dateToFieldName The name of the control representing to value within the FromGroup to check.
 * @param errorName The name of the error to be set when validation fails.
 */
function dateRangeValidate(dateFromFieldName, dateToFieldName, errorName = 'dateRangeInvalid') {
    return (group) => {
        if (Object.prototype.hasOwnProperty.call(group.controls, dateFromFieldName)) {
            // console.error('Field name is not part of given form group:', dateFromFieldName);
        }
        if (Object.prototype.hasOwnProperty.call(group.controls, dateToFieldName)) {
            // console.error('Field name is not part of given form group:', dateToFieldName);
        }
        const dateFrom = group.controls[dateFromFieldName];
        const dateTo = group.controls[dateToFieldName];
        // console.log('Validating group:', dateFrom.value, dateTo.value);
        if (dateFrom.value && dateTo.value) {
            if (new Date(dateFrom.value) > new Date(dateTo.value)) {
                return { [errorName]: true };
            }
        }
        return null;
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { DatetimeControlComponent, DatetimeControlModule, DatetimeControlPickerType, DatetimeControlService, DatetimeControlTriggerComponent, MY_MOMENT_FORMATS, dateRangeValidate };
